import { createAsyncTypes } from 'utils/ActionCreator'

export const GET_FREE_TRIAL_STATUS = createAsyncTypes('GET_FREE_TRIAL_STATUS', 'UpgradeModal')
export const SET_FREE_TRIAL_STATUS = createAsyncTypes('SET_FREE_TRIAL_STATUS', 'UpgradeModal')
